import { CreateProject, CreateProjectToken } from "$src/application/projects/commands/CreateProject";
import { CreateProjectData } from "$src/domain/projects/CreateProjectData";
import { ProjectIdentifier } from "$src/domain/projects/ProjectIdentifier";
import { useMutation, useQueryClient } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function createProject(groupStoreId: number, data: CreateProjectData)
    : Promise<ProjectIdentifier> {

    const query = container.resolve<CreateProject>(CreateProjectToken);
    return query.execute(groupStoreId, data);
}

export function useCreateProject() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ groupStoreId, data}: 
            { groupStoreId: number, data: CreateProjectData }
        ) => createProject(groupStoreId, data),
        {
            onSuccess: (data, variables) => {
                queryClient.invalidateQueries(['folders', variables.data.customerId]);
            },
            onError: (error: Error) => {
                console.error('Failed to create project:', error);
            },
            onSettled: () => {
            },
        }
    );
}